import {createBrowserHistory} from 'history';

import {ObjectUtils} from './ObjectUtils';

let history = createBrowserHistory();

export class HistoryUtils {
    static GetHistory() {
        return history;
    }
    
    static Push(url) {
        history.push(url);
    }

    static PushQueryStringUpdate(query) {
        history.push({
            pathname: window.location.pathname,
            search: '?' + ObjectUtils.BuildQueryString(query)
        })
    }
}
